export default __webpack_public_path__ + "static/media/oe_2.342fd037.mp3";